<script>
    import SubViewMonster from './subViewMonster.svelte'

    import { GetMonsterName } from '../../script/_monster'

    export let OnCapture, List, Data, DataCheck
    let activeMonster = 0
</script>

<div class='monsters'>
    {#if List.length > 0}
        {#if OnCapture}
            {#each List as item, i}
                <div class="inputPage" class:OnCapture>
                    <SubViewMonster
                        bind:OnCapture
                        bind:MonsterData={Data[i]}
                        bind:DataCheck
                    />
                </div>
            {/each}
        {:else}
            <ul class='tabMenu'>
                {#each List as item, i}
                    <li>
                        <div
                            class="txt"
                            class:active={activeMonster == i}
                            on:click={() => activeMonster = i}
                        >
                            {GetMonsterName(item)}
                        </div>
                    </li>
                {/each}
            </ul>

            <div class="inputPage">
                <SubViewMonster
                    bind:OnCapture
                    bind:MonsterData={Data[activeMonster]}
                    bind:DataCheck
                />
            </div>
        {/if}
    {:else}
        <div class="issue">등록된 몬스터가 없습니다.</div>
    {/if}
</div>

<style lang="scss">
    .monsters {
        width: calc(100%);
        height: fit-content;

        .tabMenu {
            background: $cl6;
            width: calc(100%);
            margin: 0;
            padding: 0;
            padding-top: 14px;
            padding-bottom: 12px;
            overflow: hidden;
            list-style-type: none;
            display: flex;

            li {
                float: left;
                border-right: 1px solid $cl1;

                &:last-child {
                    border-right: none;
                }

                .txt {
                    margin: 0 18px;
                    color: $cl1;
                    font-size: 20px;
                    font-family: aggro;
                    cursor: pointer;

                    &.active { color: $cl2; }
                    &:hover:not(.active) { color: $cl3; }
                }
            }
        }
        
        .inputPage {
            width: calc(100% - 40px);
            height: fit-content;
            padding: 50px 20px;
        }

        .OnCapture {
            margin: 10px 0px;
        }

        .issue {
            color: $cl4;
            font-size: 30px;
            font-family: aggro;
        }

        @include mobile {
            .tabMenu {
                padding-top: 10px;
                padding-bottom: 8px;
                
                li .txt {
                    margin: 0 8px;
                    font-size: 12px;
                }
            }
            .inputPage {
                width: calc(100% - 20px);
                height: fit-content;
                padding: 20px 10px;
            }
        }
    }
</style>